/*
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */


app.controller('RecipientsGroup', function($scope, $rootScope, recipientgroupService, $stateParams,
    _$privileges, $mdDialog) {

    var me = this;

    $scope.rows = [];

    $scope.data = {
        can_write: _$privileges.write("message")
    };


    /*
     * pagination
     */

    $scope.pagination = {
        currentPage: 1,
        totalItems: 1,
        itemsPerPage: 1
    };

    $scope.setPage = function() {
        $rootScope.checkboxList.clear();
        $scope.list.request($scope.pagination.currentPage);
    };

    /*
     * list
     */

    $scope.list = {
        "request": function(page) {
            var promise = recipientgroupService.list(page);
            promise.then(
                function(payload) {
                    $scope.rows = payload.data.data;
                    $scope.pagination = {
                        totalItems: payload.data.total,
                        currentPage: payload.data.current_page,
                        itemsPerPage: payload.data.per_page
                    };
                },
                function(errorPayload) {
                    $rootScope.notification.show('error', 'Błąd ładowania grup odbiorców', errorPayload);
                });
        }
    };

    $rootScope.checkboxList.clear();
    $scope.list.request(1);

    /*
     * panel
     */

    $scope.panel = {
        "show": function() {

        },
        "concate": function() {
            var ids = [];
            for (var i = 0; i < $scope.rows.length; i++) {
                if ($scope.rows[i].checked)
                    ids.push($scope.rows[i].id);
            }
            return ids;
        },
        "checkadmin": function() {
            var response = false;
            for (var i = 0; i < $scope.rows.length; i++) {
                if ($scope.rows[i].checked && $scope.rows[i].admin_group == 1)
                    response = true;
            }
            return response;
        },
        "copy": {
            "name": "",
            "show": function() {
                var parentEl = angular.element(document.body);
                $mdDialog.show({
                    parent: parentEl,
                    controller: function() {
                        this.parent = $scope;
                    },
                    controllerAs: 'ctrl',
                    templateUrl: "/assets/js/angular/recipients/views/modal/group_copy.html?v=2"
                });
            },
            "commit": function() {
                var promise = recipientgroupService.copy({
                    "id": $scope.panel.concate()[0],
                    "name": $scope.panel.copy.name
                });
                promise.then(
                    function(payload) {
                        $rootScope.notification.show(payload.data.code ? 'success' : 'error', payload.data.msg);
                        if (payload.data.code) {
                            $scope.list.request(1);
                            $rootScope.checkboxList.clear();
                        }
                        $scope.panel.copy.name = "";
                    });
                $mdDialog.hide();
            },
            "cancel": function() {
                $mdDialog.cancel();
            }
        },
        //        "copy": function(){
        //            var promise = recipientgroupService.copy({
        //                    "id": $scope.panel.concate()[0],
        //                    "name": $scope.data.copy_group_name
        //                });
        //                promise.then(
        //                        function (payload) {
        //                            $rootScope.notification.show(payload.data.code ? 'success' : 'error', payload.data.msg);
        //                            if (payload.data.code) {
        //                                $scope.list.request(1);
        //                                $rootScope.checkboxList.clear();
        //                            }
        //                            $scope.data.copy_group_name = "";
        //                        });
        //        },
        "activate": function() {
            var isSystemGroup = $scope.panel.checkadmin();
            if (isSystemGroup) {
                $rootScope.notification.show('error', "Aktywacja/deaktywacja grup systemowych nie jest możliwa");
            } else {
                var promise = recipientgroupService.activate($scope.panel.concate());
                promise.then(
                    function(payload) {
                        if (payload.data.code) {
                            $rootScope.notification.show('success', payload.data.msg);
                            $scope.list.request(1);
                            $rootScope.checkboxList.clear();
                        } else {
                            $rootScope.notification.show('error', payload.data.msg);
                        }
                    });
            }
        },
        "delete": function() {
            var isSystemGroup = $scope.panel.checkadmin();
            if (isSystemGroup) {
                $rootScope.notification.show('error', "Usunięcie grup systemowych nie jest możliwe");
            } else {
                var promise = recipientgroupService.delete($scope.panel.concate());
                promise.then(
                    function(payload) {
                        if (payload.data.code) {
                            $rootScope.notification.show('success', payload.data.msg);
                            $scope.list.request(1);
                            $rootScope.checkboxList.clear();
                        } else {
                            $rootScope.notification.show('error', payload.data.msg);
                        }
                    });
            }
        }
    };

    $scope.clearFilters = function() {

    };

});
